import { render, staticRenderFns } from "./UserTabPayment.vue?vue&type=template&id=6b62253f&"
import script from "./UserTabPayment.vue?vue&type=script&lang=js&"
export * from "./UserTabPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports